/** Fades a part out and nothing else. */
export const FADE_OUT: Keyframe[] = [{ opacity: 1 }, { opacity: 0 }]

/** Blurs a part in from `from` to its resting style. */
export function blurIn(blur: string, from = 'none'): Keyframe[] {
  return [
    { opacity: 0, filter: `blur(${blur})`, transform: from },
    { opacity: 1, filter: 'blur(0)', transform: 'none' },
  ]
}

/** Blurs a part out from its resting style to `to`. */
export function blurOut(blur: string, to: string): Keyframe[] {
  return [
    { opacity: 1, filter: 'blur(0)', transform: 'none' },
    { opacity: 0, filter: `blur(${blur})`, transform: to },
  ]
}

/** Takes a leaving element out of the flow at the exact place it stands, so what mounts beneath it does not move it. */
export function pinInPlace(element: HTMLElement): void {
  const { top, left, width, height } = element.getBoundingClientRect()
  Object.assign(element.style, {
    position: 'fixed',
    top: `${top}px`,
    left: `${left}px`,
    width: `${width}px`,
    height: `${height}px`,
    margin: '0',
  })
}

/** Resolves once every animation has finished or been cancelled; a missing animation counts as finished. */
export async function settled(animations: readonly (Animation | null)[]): Promise<void> {
  await Promise.allSettled(
    animations.flatMap((animation) => (animation === null ? [] : [animation.finished])),
  )
}
